import {noop, TextColor} from '@priority-software/priority-style-react';

export enum ContextMenuTextColor {
    black = 'primary-700',
    red = 'red'
}

export type ContextArrayType = {
    name: string;
    shortCode?: string;
    onClick: () => void;
    subMenu?: ContextArrayType;
    color?: TextColor;
    divider?: boolean;
}[];

export const emptyFieldContextMenu = ({
    helpFieldFunc,
    designFunc,
    openFormDesignFunc,
    restoreColumnWidthFunc,
    defineRecordColorFunc,
    showCurrentRecordColorsFunc,
    noOfFormRowsFunc,
    searchByFieldFunc,
    moveEditFunc,
    specialCopyPasteFunc,
    copySaveToBufferFunc,
    pasteFromBufferFunc,
    storeRecordsFunc,
    retrieveRecordsFunc
}): ContextArrayType => [
    {
        name: 'Field Help',
        shortCode: '[F1]',
        onClick: helpFieldFunc
    },
    {
        name: 'Design',

        onClick: designFunc,
        subMenu: [
            {name: 'Form Design', shortCode: '[Ctrl+B]', onClick: openFormDesignFunc},
            {name: 'Restore Column Widths', onClick: restoreColumnWidthFunc},
            {name: 'Define Record Color', onClick: defineRecordColorFunc},
            {name: 'Show Current Record Colors', onClick: showCurrentRecordColorsFunc},
            {name: 'No. of Form Rows', onClick: noOfFormRowsFunc}
        ]
    },
    {
        name: 'Search by Field',
        shortCode: '[Ctrl+F3]',
        onClick: searchByFieldFunc
    },
    {
        name: 'Move/Edit',
        shortCode: '[F2]',
        onClick: moveEditFunc
    },
    {
        name: 'Special Copy & Paste',

        onClick: specialCopyPasteFunc,
        subMenu: [
            {name: 'Copy & Save to Buffer', shortCode: '[Ctrl+F9]', onClick: copySaveToBufferFunc},
            {name: 'Paste from Buffer', shortCode: '[F9]', onClick: pasteFromBufferFunc},
            {name: 'Store Records', onClick: storeRecordsFunc},
            {name: 'Retrieve Records', onClick: retrieveRecordsFunc}
        ]
    }
];

export const FilledFieldContextMenu = ({
    helpFieldFunc = noop,
    designFunc = noop,
    openFormDesignFunc = noop,
    restoreColumnWidthFunc = noop,
    defineRecordColorFunc = noop,
    showCurrentRecordColorsFunc = noop,
    noOfFormRowsFunc = noop,
    searchByFieldFunc = noop,
    moveEditFunc = noop,
    specialCopyPasteFunc = noop,
    copySaveToBufferFunc = noop,
    pasteFromBufferFunc = noop,
    storeRecordsFunc = noop,
    retrieveRecordsFunc = noop,
    hideRecordFunc = noop,
    clearAllFunc = noop,
    deleteFunc = noop
}: any): ContextArrayType => [
    ...emptyFieldContextMenu({
        helpFieldFunc,
        designFunc,
        openFormDesignFunc,
        restoreColumnWidthFunc,
        defineRecordColorFunc,
        showCurrentRecordColorsFunc,
        noOfFormRowsFunc,
        searchByFieldFunc,
        moveEditFunc,
        specialCopyPasteFunc,
        copySaveToBufferFunc,
        pasteFromBufferFunc,
        storeRecordsFunc,
        retrieveRecordsFunc
    }),
    {
        name: 'Hide Record',
        shortCode: '[F7]',
        onClick: hideRecordFunc
    },
    {
        name: 'Clear All',
        shortCode: '[Ctrl+F7]',
        onClick: clearAllFunc
    },
    {
        name: 'Delete',
        shortCode: '[Ctrl+Delete]',
        color: ContextMenuTextColor.black,
        divider: true,
        onClick: deleteFunc
    }
];
